module.exports = __webpack_public_path__ + "static/media/interior.fce4f2e8.jpeg";